import { Action } from "@components/modules/Table/types";
import useAuth from "@hooks/useAuth";
import { useRef } from "react";

export default function useSalonJuriesActions() {
    const { loginAsUser } = useAuth()

    const { current: actions } = useRef<Action<Admin.Resources.Jury>[]>([
        { label: "Visit", action: row => loginAsUser(row.original.user_id) }
    ])

    return actions
}